export default "__VITE_ASSET__BWXxZPjs__"